// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"Ny","carousel__wrapper_on_sides":"Oy","arrows_wrapper":"Py","arrows_wrapper_right":"Qy","arrows_wrapper_vertical":"Ry","arrows_wrapper_on_sides":"Sy","arrow_button":"Ty","carousel_arrow_left":"Uy","carousel_arrow_left_on_side":"Vy","carousel_arrow_right_on_side":"Wy","carousel_arrow":"Xy","arrows_wrapper_rounded":"Yy","carousel__fullWidth":"Zy"};
    if(module.hot) {
      // 1713809678042
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  